import { render, staticRenderFns } from "./Species.vue?vue&type=template&id=63c2697c&scoped=true&"
import script from "./Species.vue?vue&type=script&lang=js&"
export * from "./Species.vue?vue&type=script&lang=js&"
import style0 from "./Species.vue?vue&type=style&index=0&id=63c2697c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c2697c",
  null
  
)

export default component.exports